export default __webpack_public_path__ + "static/media/dog-food.e8be79ad.png";